// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-input-module__inputWrapper--B31b8{box-sizing:border-box;padding:10px 15px;background-color:#f5f5f5}.comment-input-module__textArea--1Ps6K{font-weight:400;font-size:16px;line-height:22px;min-height:48px;width:100%;resize:vertical;font-family:Arial,serif;background-color:inherit;outline:none;overflow-y:hidden}.comment-input-module__counter--2JPj0{width:100%;text-align:right;right:15px;bottom:10px}.comment-input-module__counterText--16qDT{font-size:14px;line-height:18px;text-align:right}.comment-input-module__greyText--2KceI{color:#757575}", ""]);
// Exports
exports.locals = {
	"inputWrapper": "comment-input-module__inputWrapper--B31b8",
	"textArea": "comment-input-module__textArea--1Ps6K",
	"counter": "comment-input-module__counter--2JPj0",
	"counterText": "comment-input-module__counterText--16qDT",
	"greyText": "comment-input-module__greyText--2KceI"
};
module.exports = exports;
